export const useTelegram = () => {
  const _window: any = window
  /**
   * @description 判断是否是 Telegram 环境
   */
  const isTelegram = _window.Telegram && _window.Telegram.WebApp.initData

  const telegramWebApp = _window.Telegram?.WebApp
  const telegramWebView = _window.Telegram?.WebView

  const telegramShare = (url: string, description?: string) => {
    if (!url)
      return
    const dev_url = 'https://t.me/dfansMiniAppTestBot/dfaansTest?startapp='
    const pro_url = 'https://t.me/dFans_bot/dFans?startapp='
    const _url = import.meta.env.MODE === 'production' ? pro_url : dev_url
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(_url + url)}&text=${encodeURIComponent(description || '')}`

    telegramWebApp.openTelegramLink(shareUrl)
  }
  return {
    isTelegram, telegramWebApp, telegramWebView, telegramShare,
  }
}
